import PlantSubServicePage from "@/components/PlantSubServicePage";

const RELATED = [
  { to: "/piping", label: "Piping" },
  { to: "/electrical-instrumentation", label: "Electrical & Instrumentation" },
  { to: "/mechanical", label: "Mechanical" },
  { to: "/materials", label: "Material (MTC)" },
];

export default function CivilStructural() {
  return (
    <PlantSubServicePage
      slug="civil-structural"
      title="Civil & Structural"
      lead="Detailed civil and structural design and engineering for industries that demand the highest safety and precision standards."
      intro={[
        "ZeroLabs Digitals' Civil and Structural team brings extensive expertise in detailed design and engineering for a variety of industries — Oil & Gas, Refining, Petrochemicals, Chemicals, Pharmaceuticals, Power, Water Treatment, and Paper & Pulp.",
        "We provide comprehensive solutions that meet the highest industry standards, ensuring safety, efficiency and precision in every project.",
        "Our team utilises advanced civil and structural design software — Autodesk, AVEVA, Hexagon and Tekla — to deliver cutting-edge solutions tailored to your project's specific needs.",
      ]}
      industries={["Oil & Gas", "Refining", "Petrochemicals", "Chemicals", "Pharmaceuticals", "Power", "Water Treatment", "Paper & Pulp"]}
      tools={["Autodesk Revit Structure", "AutoCAD Civil 3D", "AVEVA", "Hexagon", "Tekla Structures", "STAAD.Pro"]}
      heroImage="https://www.thantrick.com/wp-content/uploads/2025/04/civil-1024x576.jpg"
      gallery={[
        "https://www.thantrick.com/wp-content/uploads/2025/04/civilStructural-300x193.jpg",
        "https://www.thantrick.com/wp-content/uploads/2025/04/civilstrcture-300x158.webp",
      ]}
      thantrickUrl="https://thantrick.org/civil-structural/"
      related={RELATED}
    />
  );
}
